import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { QuarterlyTaxReceiptListComponent } from './quarterly-tax-receipt-list/quarterly-tax-receipt-list.component';
import { QuarterlyTaxReceiptService } from './quarterly-tax-receipt.service';

@Component({
    selector: 'convfact-quarterly-tax-receipt-delete',
    templateUrl: './quarterly-tax-receipt-dialog-delete.component.html',
    styleUrls: ['./quarterly-tax-receipt-dialog-delete.component.css'],
    standalone: false
})

export class QuarterlyTaxReceiptDialogDeleteComponent {
    uid: string = this.data.uid;
    type: string = this.data.type;
    error_msg: string;
    error: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<QuarterlyTaxReceiptListComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        public service: QuarterlyTaxReceiptService
    ) { }

    delete() {
        this.service.delete(this.uid);
        this.error = true;
    }

    closeDialog() {
        this.dialogRef.close();
    }
}